'use client'
import { usePathname, useSearchParams } from 'next/navigation'
import { useNavigationGuard } from 'next-navigation-guard'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { useSession } from '@/lib/auth/client'
import { PosthogEvent } from './types'

export default function PostHogPageView(): null {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()
  const { data, error, isPending } = useSession()

  // Identify user
  useEffect(() => {
    if (isPending || error || !data) return

    posthog?.identify(data.user.id, data.user)
  }, [data, posthog])

  // Track pageviews
  useEffect(() => {
    if (!pathname) return
    if (typeof window === 'undefined') return

    let url = window.origin + pathname
    if (searchParams.toString()) {
      url = `${url}?${searchParams.toString()}`
    }
    posthog?.capture?.(PosthogEvent.PAGEVIEW, {
      $current_url: url,
    })
  }, [pathname, searchParams, posthog])

  // Track pageleave
  useNavigationGuard({
    enabled: () => {
      posthog?.capture?.(PosthogEvent.PAGELEAVE)
      return false
    },
  })

  return null
}
